import { Pipe, PipeTransform } from '@angular/core';
import { SponsorData } from '../../providers/sponsor';

@Pipe({
  name: 'sponsor',
})
export class SponsorPipe implements PipeTransform {

  constructor(
    private sponsorData: SponsorData
  ) {}

  transform(idSponsor: string, idClient: string) {
    return this.sponsorData.getEventSponsor(idClient, idSponsor);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/sponsor/sponsor.ts